import { render, staticRenderFns } from "./TestCard.vue?vue&type=template&id=196f7be5"
import script from "./TestCard.vue?vue&type=script&lang=js"
export * from "./TestCard.vue?vue&type=script&lang=js"
import style0 from "./TestCard.vue?vue&type=style&index=0&id=196f7be5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports